<template>
  <div :style="[scoreColor]" data-bs-toggle="tooltip" :data-bs-title="tooltipString" ref="tooltip">
    <i v-if="type === 'transfer'" class="icon icon-transfer"></i>
    <i v-else-if="type === 'arrival'" class="icon icon-clock"></i>
    {{ scoreFormatted }}
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { rdylgrColormap } from '~/utils/colormap'
import { useMainStore } from '~/stores/main'
import { storeToRefs } from 'pinia'
import { Tooltip } from 'bootstrap'

const store = useMainStore()
const { punctualityLimitDuration } = storeToRefs(store)

const {
  score,
  inline = false,
  type = 'transfer'
} = defineProps<{
  score: number | 'cancelled' | 'direct' | undefined
  inline?: boolean
  type?: 'arrival' | 'transfer'
}>()

const scoreFormatted = computed(() => {
  if (score === 'cancelled') {
    return 'Entfällt'
  } else if (score === 'direct') {
    return 'Direkt'
  } else if (score === undefined) {
    return '-'
  } else {
    return `${Math.trunc(score * 100)}%`
  }
})

const color = computed(() => {
  if (score === 'cancelled') {
    return rdylgrColormap(0, 0.5, 1, 200)
  } else if (score === 'direct') {
    return rdylgrColormap(1, 0.5, 1, 200)
  } else if (score === undefined) {
    return rdylgrColormap(0.5, 0.5, 1, 200)
  } else {
    return rdylgrColormap(score, 0.5, 1, 200)
  }
})

const scoreColor = computed(() => {
  const style = {
    color: color.value,
    'border-color': color.value + ' !important'
  }
  if (inline) {
    return {
      ...style,
      display: 'inline-block'
    }
  }

  return style
})

const tooltipString = computed(() => {
  if (type === 'transfer') {
    return 'Anschlusssicherheit'
  } else if (type === 'arrival') {
    return (
      'Wahrscheinlichkeit, dass der letzte Zug maximal ' +
      punctualityLimitDuration.value.asMinutes() +
      'min zusätzliche Verspätung bekommt'
    )
  }
})

const tooltip = useTemplateRef('tooltip')

onMounted(() => {
  new Tooltip(tooltip.value!)
})
</script>
